import Request from '../utils/request'

export function getBenefitByNameListApi (params) {
  return Request({
    url: '/follow/benefitGuaranteePayPlan/getByName',
    method: 'get',
    params
  })
}

export function getByPatientIdAndCategoryIdApi (params) {
  return Request({
    url: '/follow/patientAccount/guaranteeLimit/getByPatientIdAndStandardId',
    method: 'get',
    params
  })
}
